document.addEventListener("DOMContentLoaded", () => {
  const sliderIds = new Set([
    ...document.querySelectorAll('.slideshow-arrow--prev[data-slider-id], .slideshow-arrow--next[data-slider-id]')
  ].map(btn => btn.getAttribute('data-slider-id')));

  sliderIds.forEach(sliderId => {
    const slideshow = document.getElementById(sliderId);
    if (!slideshow) return;

    const prevBtn = document.querySelector(`.slideshow-arrow--prev[data-slider-id="${sliderId}"]`);
    const nextBtn = document.querySelector(`.slideshow-arrow--next[data-slider-id="${sliderId}"]`);

    function updateArrowStates() {
      if (!slideshow.flickity) return;
      const flickity = slideshow.flickity;
      const currentIndex = flickity.selectedIndex;
      const lastIndex = flickity.slides.length - 1;

      if (prevBtn) prevBtn.classList.toggle('slideshow-arrow--disabled', currentIndex === 0);
      if (nextBtn) nextBtn.classList.toggle('slideshow-arrow--disabled', currentIndex === lastIndex);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (slideshow.flickity) slideshow.flickity.previous();
        setTimeout(updateArrowStates, 50);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (slideshow.flickity) slideshow.flickity.next();
        setTimeout(updateArrowStates, 50);
      });
    }

    function waitForFlickity(attempts = 0) {
      if (slideshow.flickity) {
        updateArrowStates();
        slideshow.flickity.on('change', updateArrowStates);
        slideshow.flickity.on('settle', updateArrowStates);
        window.addEventListener('resize', updateArrowStates);
      } else if (attempts < 100) {
        setTimeout(() => waitForFlickity(attempts + 1), 100);
      }
    }
    waitForFlickity();
  });
});